import React, { useState, useEffect, forwardRef } from 'react';
import {
  Slide,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  TableContainer,
  Table,
  TableBody,
  Typography,
  TableRow,
  TableCell,
  Grid,
  Paper,
} from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../common/iconify.component';
import SnackbarInfo from '../common/snackbar-info.component';
import { getSearchListData } from '../../services/hls-transcoder.service';
import Loading from '../table-elements/loading.component';
import AddEditBucket from './add-edit-bucket.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ManageBuckets = ({ title, onCancel, onManageBucketActionSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });

  const handleActionCancel = () => {
    setSelectedRowData(null);
  };
  const handleActionSuccess = (message = '') => {
    setSnackbarInfo({ ...snackbarInfo, show: false });
    onManageBucketActionSuccess();

    if (message) {
      setTimeout(() => {
        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'success',
          message,
        });
      }, 100);
    }

    setSelectedRowData(null);
    setLoading(true);
    setReloadCounter((prev) => prev + 1);
  };

  useEffect(() => {
    getSearchListData()
      .then((res) => {
        setRowData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
        setLoading(false);
      });
  }, [reloadCounter]);

  return (
    <Dialog
      open
      aria-labelledby="add-dialog-title"
      aria-describedby="add-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="add-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="add-dialog-description">
        {loading && <Loading />}

        {!loading && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5} md={5}>
              <TableContainer component={Paper} variant="elevation" square>
                <Table>
                  <TableBody>
                    {rowData.length > 0 &&
                      rowData.map((r) => (
                        <TableRow key={`row-${r.id}`}>
                          <TableCell
                            key={`data-row-${r.id}`}
                            variant="body"
                            width="95%"
                            onClick={() => setSelectedRowData(r)}
                            sx={{
                              background:
                                selectedRowData?.id === r.id ? '#919eab1f' : '',
                              fontSize: '0.875rem !important',
                              padding: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="span"
                              color="inherit"
                            >
                              {r.name}
                            </Typography>
                          </TableCell>

                          {selectedRowData?.id === r.id && (
                            <IconButton sx={{ px: 0 }}>
                              <Iconify icon="material-symbols:arrow-right" />
                            </IconButton>
                          )}
                        </TableRow>
                      ))}

                    {rowData.length === 0 && (
                      <TableRow>
                        <Typography
                          textAlign="center"
                          variant="body2"
                          sx={{ my: 20 }}
                        >
                          No data found
                        </Typography>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={12} sm={7} md={7}>
              <AddEditBucket
                dataId={selectedRowData?.id || 0}
                rowData={selectedRowData}
                onCancel={handleActionCancel}
                onSuccess={handleActionSuccess}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

ManageBuckets.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onManageBucketActionSuccess: PropTypes.func.isRequired,
};

export default ManageBuckets;
